var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoamingPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    x: 0,
    y: 0,
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464555",
    d: "M188.7 243H67.3c-8.6 0-15.5-7-15.5-15.5v-199c0-8.6 7-15.5 15.5-15.5h121.4c8.6 0 15.5 7 15.5 15.5v199c0 8.5-6.9 15.5-15.5 15.5z",
    opacity: 1,
    "data-original": "#606060",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dadadd",
    d: "M184.7 232.8H71.3c-5.8 0-10.5-4.7-10.5-10.5V33.7c0-5.8 4.7-10.5 10.5-10.5h113.4c5.8 0 10.5 4.7 10.5 10.5v188.6c0 5.8-4.7 10.5-10.5 10.5z",
    opacity: 1,
    "data-original": "#e9ffe9",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464555",
    d: "M141.8 45h-27.6c-4.1 0-7.5-3.4-7.5-7.5s3.4-7.5 7.5-7.5h27.6c4.1 0 7.5 3.4 7.5 7.5S146 45 141.8 45z",
    opacity: 1,
    "data-original": "#606060",
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#7cc17c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128 170.7c-19.1 0-34.6-15.5-34.6-34.6s15.5-34.6 34.6-34.6 34.6 15.5 34.6 34.6-15.5 34.6-34.6 34.6zm0-66.3c-17.4 0-31.6 14.2-31.6 31.6s14.2 31.6 31.6 31.6 31.6-14.2 31.6-31.6-14.2-31.6-31.6-31.6z",
    fill: "#464555",
    opacity: 1,
    "data-original": "#7cc17c",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 170.7c-12.3 0-22.4-15.5-22.4-34.6s10-34.6 22.4-34.6 22.4 15.5 22.4 34.6-10.1 34.6-22.4 34.6zm0-66.3c-10.7 0-19.4 14.2-19.4 31.6s8.7 31.6 19.4 31.6 19.4-14.2 19.4-31.6-8.7-31.6-19.4-31.6z",
    fill: "#464555",
    opacity: 1,
    "data-original": "#7cc17c",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 170.7c-6.4 0-9.4-18-9.4-34.6 0-16.7 2.9-34.6 9.4-34.6s9.4 18 9.4 34.6c0 16.7-3 34.6-9.4 34.6zm0-66.3c-2.2 0-6.4 11.2-6.4 31.6 0 20.5 4.2 31.6 6.4 31.6s6.4-11.2 6.4-31.6-4.2-31.6-6.4-31.6z",
    fill: "#464555",
    opacity: 1,
    "data-original": "#7cc17c",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9 134.6h66.3v3H94.9zM100.3 152.7h55.4v3h-55.4zM100.3 116.4h55.4v3h-55.4z",
    fill: "#464555",
    opacity: 1,
    "data-original": "#7cc17c",
    className: ""
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoamingPhone);
export default __webpack_public_path__ + "static/media/roaming-phone.e8d841d256e003a2a14a26e26634d42c.svg";
export { ForwardRef as ReactComponent };